import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Select, Modal } from "antd";
import { rangeGenerator } from "../../../base/utils";
import { Note } from "../../../helbest";
import { API } from "../../../request/api";

// icons
import { ReactComponent as BottomArrow } from "../../../assets/svg/bottom-arrow.svg";
import IconCross from "../../../assets/images/icons/cross_rv.png";
import IconCar from "../../../assets/images/icons/car.png";
import Button from "../../components/ui/Button";

const { Option } = Select;

const grDates = rangeGenerator(2022, 1980);

const EditCar = (props) => {
  const [brands, set_brands] = useState([]);
  const [models, set_models] = useState([]);

  const [state, set_state] = useState({
    btn_save: "Submit",
    type_selected: null,
    brand_selected: null,
    model_selected: null,
    year: null,
    user_id: 0,
  });

  const { car, edit_car, closeModal, updateMyCar } = props;

  const setInit = () => {
    let type = car?.car.type;
    let brand = car?.car_brand_id;
    let model = car?.car;
    let year = car?.year;
    let user_car_id = car?.user_car_id;
    let is_jalali = car?.car.is_jalali;
    set_state({
      ...state,
      type_selected: type,
      brand_selected: brand,
      model_selected: model,
      year: year,
      is_jalali: is_jalali,
      user_id: user_car_id,
    });
    set_brands([]);
    set_models([]);

    API.get
      .carsBrands(type)
      .then((response) => {
        if (response.success) {
          set_brands(response.data);
        }
      })
      .catch((error) => {
        console.log("Error : ", error);
      });

    API.get
      .carsModels(brand)
      .then((response) => {
        if (response.success) {
          set_models(response.data);
        }
      })
      .catch((error) => {
        console.log("Error : ", error);
      });
  };

  const handleSelectType = (type) => {
    set_state({
      ...state,
      type_selected: type,
      brand_selected: null,
      model_selected: null,
      year: null,
    });

    API.get
      .carsBrands(type)
      .then((response) => {
        if (response.success) {
          set_brands(response.data);
        }
      })
      .catch((error) => {
        console.log("Error : ", error);
      });
  };

  const handleSelectBrand = (br) => {
    set_state({
      ...state,
      brand_selected: br,
      model_selected: null,
      year: null,
    });
    API.get
      .carsModels(br)
      .then((response) => {
        if (response.success) {
          set_models(response.data);
        }
      })
      .catch((error) => {
        console.log("Error : ", error);
      });
  };

  const handleSelectModel = (model) => {
    set_state({
      ...state,
      model_selected: model,
    });
  };

  const handleSelectYear = (year) => {
    set_state({
      ...state,
      year: year,
    });
  };

  const handleSetEditCar = () => {
    if (
      state.year != null &&
      state.type_selected != null &&
      state.brand_selected &&
      state.model_selected != null
    ) {
      set_state({
        ...state,
        btn_save: "waiting...",
      });

      API.put
        .userCar(state.user_id, state.model_selected.id, state.year)
        .then((response) => {
          updateMyCar(response.data);
          closeModal();
          set_state({
            btn_save: "Submit",
          });
        })
        .catch((error) => {});
    } else {
      Note.error("please enter complete information.");
    }
  };

  useEffect(() => {
    /*
     * change initial data when user_car_id changed
     */
    if (state.user_id !== car?.user_car_id) {
      setInit();
    }
    // eslint-disable-next-line
  }, [car]);

  return (
    <Modal
      closeIcon={
        <img
          src={IconCross}
          style={{ width: "20px", height: "20px" }}
          alt="x"
        />
      }
      title=""
      open={edit_car}
      onCancel={() => {
        let type = car?.car.type;
        let brand = car?.car_brand_id;
        let model = car?.car;
        let year = car?.year;
        closeModal();

        /*
         * if user change the data and regrets changing data of current item
         * states will be initialize with current data of the item
         */
        if (
          state.type_selected !== type ||
          state.brand_selected !== brand ||
          state.model_selected !== model ||
          state.year !== year
        ) {
          setInit();
        }
      }}
      footer={false}
    >
      <div className="flex column">
        <div className="flex flex-column center-content icon_modal_my_new_car center column mt-5">
          <img className="cars-modal-icon" src={IconCar} alt="car" />
          <label>Edit Car</label>
        </div>
        <div className="create_car_box flex column center">
          <div className="select_box col12">
            <Select
              className="selectCarModalSelectBox"
              notFoundContent="no items found"
              bordered={false}
              placeholder="type"
              value={state.type_selected}
              suffixIcon={<BottomArrow width={10} height={10} />}
              onChange={(type) => {
                handleSelectType(type);
              }}
            >
              <Option className="dir-rtl" value="riding" key="riding">
                Passenger vehicle
              </Option>
              <Option className="dir-rtl" value="heavy" key="heavy">
                Commercial vehicle
              </Option>
            </Select>
          </div>
          <div className="select_box col12">
            <Select
              className="selectCarModalSelectBox"
              notFoundContent="no items found"
              bordered={false}
              placeholder="brand"
              defaultValue="brand"
              suffixIcon={<BottomArrow width={10} height={10} />}
              value={state.brand_selected}
              onChange={(br) => handleSelectBrand(br)}
            >
              {brands.length > 0 &&
                brands.map((val) => {
                  return (
                    <Option className="dir-rtl" value={val.id} key={val.id}>
                      {val.name}
                    </Option>
                  );
                })}
            </Select>
          </div>
          <div className="select_box col12">
            <Select
              className="selectCarModalSelectBox"
              notFoundContent="no items found"
              bordered={false}
              placeholder="model"
              suffixIcon={<BottomArrow width={10} height={10} />}
              value={state.model_selected?.name}
              onChange={(model) => {
                handleSelectModel(JSON.parse(model));
              }}
            >
              {models.length > 0 &&
                models.map((model) => {
                  return (
                    <Option
                      className="dir-rtl"
                      value={JSON.stringify(model)}
                      key={model.id}
                    >
                      {model.name}
                    </Option>
                  );
                })}
            </Select>
          </div>
          <div className="select_box col12">
            <Select
              className="selectCarModalSelectBox"
              notFoundContent="no items found"
              bordered={false}
              placeholder="year"
              defaultValue="year"
              suffixIcon={<BottomArrow width={10} height={10} />}
              value={state.year}
              onChange={(year) => handleSelectYear(year)}
            >
              {grDates.map((val, ind) => {
                return (
                  <Option key={ind} value={val}>
                    {val}
                  </Option>
                );
              })}
            </Select>
            <div className="flex col12 center">
              <Button
                style_width="100%"
                style_marginTop={16}
                className="submit-add-edit-car-btn"
                onClick={handleSetEditCar}
              >
                {state.btn_save}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

const mstp = (state) => ({
  Login: state.Login,
});
export default connect(mstp)(EditCar);
